angular.module('qkr').factory('loyaltyService', ($http, appConfig) => ({
    	addRewardScheme(addRewardSchemeCommand) {
    		return $http.post(appConfig.apiUrl + 'loyalty/addRewardScheme', addRewardSchemeCommand);
    	},
    	
    	updateRewardScheme(updateRewardSchemeCommand) {
    		return $http.post(appConfig.apiUrl + 'loyalty/updateRewardScheme', updateRewardSchemeCommand);
    	},
    	
    	getRewardScheme() {
    		return $http.get(appConfig.apiUrl + 'loyalty/getRewardScheme', {
                withCredentials: true
            });
    	},
    	
    	activateOrDeactivateRewardScheme(activate) {
    		return $http.post(appConfig.apiUrl + 'loyalty/activateOrDeactivateRewardScheme', {value: activate});
    	}
    }));



// WEBPACK FOOTER //
// ./src/services/loyalty.services.js